export default __webpack_public_path__ + "static/brass_paystack_cover_v3-0077c25a8fea895df5917dcc41794c1c.png";